import { Component, Inject, OnInit } from '@angular/core';
import {
   MatDialog,
   MatDialogRef,
   MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { PDFDocumentProxy } from 'ng2-pdf-viewer';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReportService } from 'src/app/sharedModule/report-v2/services/report.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
   selector: 'app-source-preview',
   templateUrl: './source-preview.component.html',
   styleUrls: ['./source-preview.component.scss'],
})
export class SourcePreviewComponent implements OnInit {
   documentContent: string[];
   processedContent: SafeHtml;
   pdfSrc;
   requestPurpose;
   enablePII = false;
   deletedFromArchive= false;
   constructor(
      private reportService: ReportService,
      public dialogRef: MatDialogRef<SourcePreviewComponent>,
      public dialog: MatDialog,
      private spinnerService: NgxSpinnerService,
      private sanitizer: DomSanitizer,
      /**
       * Used to pass data in component through dialog
       */
      @Inject(MAT_DIALOG_DATA) public data: any
   ) {}

   ngOnInit(): void {
      this.pdfSrc = this.data.presignedS3UrlPreview;
      this.documentContent = this.data.documentContent;
      if (this.documentContent['deletedFromArchive']) {
         this.deletedFromArchive = true;
         this.processedContent = this.sanitizer.bypassSecurityTrustHtml(this.documentContent['content']);
      }  else {
            this.deletedFromArchive = false;
         this.processedContent = this.sanitizer.bypassSecurityTrustHtml(this.documentContent['content']);
      }

   }

   processDocumentContent(content: any): SafeHtml {
      this.enablePII = content['enablePII'];
      if (this.enablePII && content['content']) {
         const cleanContent = content['content'].replace(/^"|"$/g, '');
         const contentLines = cleanContent.split('" "');
         const htmlContent = contentLines.map(text => {
            const processedText = text.replace(/<(\w+)>/g, '<span class="pii">&lt;$1&gt;</span>');
            return `<div>${processedText}</div>`;
         }).join('');
         
         return this.sanitizer.bypassSecurityTrustHtml(htmlContent);
      } else {
         return this.sanitizer.bypassSecurityTrustHtml('');
      }
   }

   callBackFn(pdf: PDFDocumentProxy) {
   }

   submit() {
      this.spinnerService.show()
      this.reportService
        .sentContentRequest(
          this.data.sourceId,
          this.data.sourceSubmissionId,
          this.requestPurpose,
          this.data.index
        )
        .pipe()
        .subscribe(
          (data) => {
            this.documentContent = data.documentContent;
            this.processedContent = this.processDocumentContent(this.documentContent);
            this.data.hasAccess = true;
            this.data.submission = data.submission
            this.pdfSrc = data.presignedS3UrlPreview,
            this.spinnerService.hide();

          },
          (error) => {
            this.spinnerService.hide();
          }
        );
   }
}
